export default "__VITE_ASSET__0d3778fd__"